<form class="lv-artefact">
  <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                    [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                    [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                    [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"></lv-label-tooltip>
  <mat-form-field class="lv-material-form-input">
    <div class="lv-progress-bar-search-simple">
      <mat-progress-bar *ngIf="isSearching" mode="indeterminate" color="accent"></mat-progress-bar>
    </div>
    <div class="lv-input-field"
         [ngClass]="{'lv-error-state': (searchMulti.errors?.ERROR || searchMulti.errors?.required && searchMulti.touched) ||
                      (!!uiArtefakt.UIMeldung?.length && searchMulti.touched)}">
      <input type="text"
             matInput
             [ngModel]="model"
             #searchMulti="ngModel"
             [required]="uiArtefakt.PflichtfeldJN"
             (ngModelChange)="filterOptions($event)"
             (blur)="onBlur()"
             [name]="uiArtefakt.Identifikator"
             [matAutocomplete]="auto"
             [errorStateMatcher]="stateMatcherFormInput"
             [disabled]="isDisabled">
    </div>
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                      (optionSelected)="setValue($event.option.value)">
      <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option.WertAnzeige"
                  [innerHTML]="option.WertAnzeige | highlight : searchMulti.value">
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-error class="lv-mat-error"
             *ngIf="searchMulti.errors?.required && searchMulti?.touched && !selectedItems?.length">
    <ng-container *ngIf="!uiArtefakt.FehlertextPflichtfeld">
      {{'ERRORS.REQUIRED' | translate}}
    </ng-container>
    <ng-container *ngIf="!!uiArtefakt.FehlertextPflichtfeld">
      {{uiArtefakt.FehlertextPflichtfeld}}
    </ng-container>
  </mat-error>
  <mat-error class="lv-mat-error"
             *ngIf="searchMulti?.touched && searchMulti.errors && searchMulti.errors.ERROR">
    {{searchMulti.errors.ERROR}}
  </mat-error>
  <mat-error class="lv-mat-error"
             *ngIf="!!uiArtefakt.UIMeldung?.length && searchMulti.touched">
    {{uiArtefakt.UIMeldung[0].Meldungstext}}
  </mat-error>
  <div class="lv-gewaehlte-werte" *ngIf="selectedItems?.length">
    <div class="lv-gewaehlte-werte-ueberschift-container">
      <div class="lv-gewaehlte-werte-ueberschift">
        Ausgewählt:
      </div>
    </div>
    <div [@inOut] *ngFor="let item of selectedItems, trackBy: trackByFn">
      <div class="lv-gewaehlte-werte-item">
        <div>{{item.WertAnzeige}}</div>
        <div>
          <mat-icon class="lv-dialog-icon-trash" [svgIcon]="'Trash'"
                    (click)="onDeleteItemClicked(item)"></mat-icon>
        </div>
      </div>
    </div>
  </div>
  <lv-infotext-permanent [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
</form>
